import "../extensions/object";
import "es6-promise/auto";
class AjaxGlobals {
    constructor() {
    }
    static GetInstance() {
        if (!AjaxGlobals.instance) {
            AjaxGlobals.instance = new AjaxGlobals();
        }
        return AjaxGlobals.instance;
    }
    GetDefaultData() {
        return this.defaultData;
    }
    SetDefaultData(data) {
        this.defaultData = Object.merge(this.defaultData, data);
    }
}
export class AjaxRequest {
    constructor() {
    }
    Send(method, url, data, options) {
        return new Promise((resolve, reject) => {
            let request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (this.readyState === 4) {
                    let response = new AjaxResponse();
                    response.xhr = request;
                    response.data = this.response;
                    response.status = this.status;
                    response.statusText = this.statusText;
                    if (this.status >= 200 && this.status <= 204) {
                        resolve(response);
                    }
                    if (this.status >= 400) {
                        reject(response);
                    }
                }
            };
            let urlParams = "";
            if (data instanceof FormData) {
                urlParams = new URLSearchParams(data).toString();
                let defaults = AjaxRequestGlobals.GetDefaultData();
                for (let prop in defaults) {
                    data.append(prop, defaults[prop]);
                }
                ;
            }
            else {
                urlParams = Object.param(data);
                data = Object.merge(AjaxRequestGlobals.GetDefaultData(), data);
            }
            if (method == AjaxMethod.GET) {
                if (!String.isNullOrWhitespace(urlParams)) {
                    url += (url.indexOf("?") == -1 ? "?" : "&") + urlParams;
                }
            }
            request.open(method, url, true);
            if (options) {
                if (options.ResponseType) {
                    request.responseType = options.ResponseType;
                }
                if (options.RequestType) {
                    request.setRequestHeader("Content-Type", options.RequestType);
                }
            }
            if (method != AjaxMethod.GET) {
                if (data instanceof FormData) {
                    request.send(data);
                }
                else {
                    request.send(urlParams);
                }
            }
            else {
                request.send();
            }
        });
    }
}
export var AjaxMethod;
(function (AjaxMethod) {
    AjaxMethod["POST"] = "POST";
    AjaxMethod["GET"] = "GET";
    AjaxMethod["PUT"] = "PUT";
    AjaxMethod["UPDATE"] = "UPDATE";
    AjaxMethod["DELETE"] = "DELETE";
})(AjaxMethod || (AjaxMethod = {}));
export var AjaxRequestType;
(function (AjaxRequestType) {
    AjaxRequestType["JSON"] = "application/json;charset=UTF-8";
    AjaxRequestType["FORM"] = "application/x-www-form-urlencoded";
    AjaxRequestType["MULTIPART"] = "multipart/form-data";
    AjaxRequestType["PLAIN"] = "text/plain";
})(AjaxRequestType || (AjaxRequestType = {}));
export var AjaxResponseType;
(function (AjaxResponseType) {
    AjaxResponseType["JSON"] = "json";
    AjaxResponseType["TEXT"] = "text";
    AjaxResponseType["HTML"] = "document";
    AjaxResponseType["XML"] = "document";
    AjaxResponseType["ARRAY_BUFFER"] = "arraybuffer";
    AjaxResponseType["BLOB"] = "blob";
})(AjaxResponseType || (AjaxResponseType = {}));
export class AjaxResponse {
}
export let AjaxRequestGlobals = AjaxGlobals.GetInstance();
